import type { ReactNode } from "react";

import type { BaseInputProps } from "../base-input/base-input";

import { useController, useFormContext } from "react-hook-form";

import { BaseInput } from "../base-input/base-input";

type NumberInputProps = Omit<BaseInputProps, "type"> & {
	name: string;
};
export function NumberInput({ name, ...props }: NumberInputProps): ReactNode {
	const { control } = useFormContext();
	const { field, fieldState } = useController({ control, name });

	return (
		<BaseInput
			errorMessage={fieldState.error?.message}
			isInvalid={fieldState.invalid}
			onChange={field.onChange}
			value={field.value as string}
			{...props}
			type="number"
		/>
	);
}
